const storeBasePath = '/lojas'
const companyBasePath = '/empresas'

export default [
  {
    path: '/lojas/listar',
    name: 'store-list',
    component: () => import('@/views/pages/store/StoreList.vue'),
    meta: {
      pageTitle: 'Lojas',
      navActiveLink: 'store-list',
      resource: 'Store',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Gestão de Lojas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/adicionar',
    name: 'store-add',
    component: () => import('@/views/pages/store/StoreMaintain.vue'),
    meta: {
      pageTitle: 'Nova Loja',
      navActiveLink: 'store-list',
      resource: 'Store',
      action: 'Create',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Gestão de Lojas',
          to: `${storeBasePath}/listar`,
        },
        {
          text: 'Nova Loja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/manter/:id',
    name: 'store-maintain',
    component: () => import('@/views/pages/store/StoreMaintain.vue'),
    meta: {
      pageTitle: 'Manter Loja',
      navActiveLink: 'store-list',
      resource: 'Store',
      action: 'Update',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Gestão de Lojas',
          to: `${storeBasePath}/listar`,
        },
        {
          text: 'Manter Loja',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/configuracao-delivery',
    name: 'delivery-config-list',
    component: () => import('@/views/pages/store/delivery-config/DeliveryConfigList.vue'),
    meta: {
      pageTitle: 'Configuração de Delivery',
      navActiveLink: 'delivery-config-list',
      resource: 'Store',
      action: 'ViewDeliveryConfig',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Configuração de Delivery',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/configuracao-delivery/editar',
    name: 'delivery-config-manage',
    component: () => import('@/views/pages/store/delivery-config/DeliveryConfigManage.vue'),
    meta: {
      pageTitle: 'Configuração de Delivery',
      navActiveLink: 'delivery-config-list',
      resource: 'Store',
      action: 'ViewDeliveryConfig',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Configuração de Delivery',
          to: '/lojas/configuracao-delivery',
        },
        {
          text: 'Manutenção',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/configuracao-delivery/campanhas',
    name: 'delivery-config-campaigns',
    component: () => import('@/views/pages/store/delivery-config/DeliveryConfigCampaigns.vue'),
    meta: {
      pageTitle: 'Campanhas de Frete',
      navActiveLink: 'delivery-config-list',
      resource: 'Store',
      action: 'ViewDeliveryConfig',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Configuração de Delivery',
          to: '/lojas/configuracao-delivery',
        },
        {
          text: 'Campanhas de Frete',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/horarios-funcionamento',
    name: 'opening-hours-list',
    component: () => import('@/views/pages/store/opening-hours/OpeningHoursList.vue'),
    meta: {
      pageTitle: 'Horários de Funcionamento',
      navActiveLink: 'opening-hours-list',
      resource: 'Store',
      action: 'ViewOpeningHours',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Horários de Funcionamento',
          active: true,
        },
      ],
    },
  },
  {
    path: '/lojas/horarios-funcionamento/editar',
    name: 'opening-hours-manage',
    component: () => import('@/views/pages/store/opening-hours/OpeningHoursManage.vue'),
    meta: {
      pageTitle: 'Horários de Funcionamento',
      navActiveLink: 'opening-hours-list',
      resource: 'Store',
      action: 'ViewOpeningHours',
      breadcrumb: [
        {
          text: 'Lojas',
        },
        {
          text: 'Horários de Funcionamento',
          to: '/lojas/horarios-funcionamento',
        },
        {
          text: 'Manutenção',
          active: true,
        },
      ],
    },
  },
  {
    path: '/empresas/listar',
    name: 'company-list',
    component: () => import('@/views/pages/company/CompanyList.vue'),
    meta: {
      pageTitle: 'Empresas',
      navActiveLink: 'company-list',
      resource: 'Company',
      action: 'Read',
      breadcrumb: [
        {
          text: 'Empresas',
        },
        {
          text: 'Gestão de Empresas',
          active: true,
        },
      ],
    },
  },
  {
    path: '/empresas/adicionar',
    name: 'company-add',
    component: () => import('@/views/pages/company/CompanyMaintain.vue'),
    meta: {
      pageTitle: 'Nova Empresa',
      navActiveLink: 'company-list',
      resource: 'Company',
      action: 'Create',
      breadcrumb: [
        {
          text: 'Empresas',
        },
        {
          text: 'Gestão de Empresas',
          to: `${companyBasePath}/listar`,
        },
        {
          text: 'Nova Empresa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/empresas/manter/:id',
    name: 'company-maintain',
    component: () => import('@/views/pages/company/CompanyMaintain.vue'),
    meta: {
      pageTitle: 'Manter Empresa',
      navActiveLink: 'company-list',
      resource: 'Company',
      action: 'Update',
      breadcrumb: [
        {
          text: 'Empresas',
        },
        {
          text: 'Gestão de Empresas',
          to: `${companyBasePath}/listar`,
        },
        {
          text: 'Manter Empresa',
          active: true,
        },
      ],
    },
  },
]
